export const getBrowserCountryCode = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  const { navigator } = window;

  if (!navigator) {
    return '';
  }

  const extractCountryFromLocale = (locale) => {
    if (!locale || typeof locale !== 'string') {
      return '';
    }

    const localeWithoutModifiers = locale.split('@')[0];
    const parts = localeWithoutModifiers.split(/[-_]/);

    for (const part of parts) {
      if (part && /^[A-Za-z]{2}$/.test(part)) {
        return part.toUpperCase();
      }
    }

    return '';
  };

  const locales = [];

  if (Array.isArray(navigator.languages)) {
    locales.push(...navigator.languages);
  }

  if (navigator.language) {
    locales.push(navigator.language);
  }

  if (navigator.userLanguage) {
    locales.push(navigator.userLanguage);
  }

  if (navigator.browserLanguage) {
    locales.push(navigator.browserLanguage);
  }

  try {
    const intlLocale = Intl?.DateTimeFormat?.().resolvedOptions?.().locale;
    if (intlLocale) {
      locales.push(intlLocale);
    }
  } catch {
    // Swallow Intl errors
  }

  for (const locale of locales) {
    const country = extractCountryFromLocale(locale);
    if (country) {
      return country;
    }
  }

  return '';
};